import { yulavaEmailFormlyConfig } from '@shared/utils/email/email-formly';
import { QueryMembersParticipatingCompetitionArgs, QueryTeamsParticipatingCompetitionArgs } from './../types';
import { extraCompetitionQuery, membersParticipatingCompetitionQuery, publicCompetitionsQuery, teamsParticipatingCompetitionQuery } from './../operations/queries/competitionQueries';
import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map} from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import gql from 'graphql-tag';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { TYPE_FORM_CHECK, TYPE_FORM_COLOR, TYPE_FORM_DATE, TYPE_FORM_DATETIME, TYPE_FORM_EMAIL, TYPE_FORM_LIST_VALOURS, TYPE_FORM_NUMBER, TYPE_FORM_TEXT, TYPE_FORM_TEXT_AREA } from '@shared/constants';
import { QueryPublicCompetitionsArgs } from '../types';

@Injectable({
  providedIn: 'root'
})

export class CompetitionService {

  constructor(
    private apollo: Apollo,
    private translateService: TranslateService
    ) {

  }

  getPublicCompetitions(data:QueryPublicCompetitionsArgs){
    return this.apollo.query<any>({
      query: gql(publicCompetitionsQuery),
      variables:  data ,
    }).pipe(
      map(result => result.data.publicCompetitions)
    );
  }

  getPublicExtraCompetition(data:QueryPublicCompetitionsArgs){
    return this.apollo.query<any>({
      query: gql(extraCompetitionQuery),
      variables:  data ,
    }).pipe(
      map(result => result.data.publicExtraCompetition)
    );
  }

  getTeamsParticipatingCompetition(data:QueryTeamsParticipatingCompetitionArgs){
    return this.apollo.query<any>({
      query: gql(teamsParticipatingCompetitionQuery),
      variables:  data ,
    }).pipe(
      map(result => result.data.teamsParticipatingCompetition)
    );
  }

  getMembersParticipatingCompetition(data:QueryMembersParticipatingCompetitionArgs){
    return this.apollo.query<any>({
      query: gql(membersParticipatingCompetitionQuery),
      variables:  data ,
    }).pipe(
      map(result => result.data.membersParticipatingCompetition)
    );
  }

  /* getPublicCompetition(data:PublicCompetitionQueryModel){
    return this.apollo.query<any>({
      query: gql(publicCompetitionQuery),
      variables:  data ,
    }).pipe(
      map(result => result.data.publicCompetition)
    );
  }

  getPublicListCompetitionMembers(data:PublicListCompetitionMembersQueryModel){
    return this.apollo.query<any>({
      query: gql(publicListCompetitionMembersQuery),
      variables:  data ,
    }).pipe(
      map(result => result.data.publicListCompetitionMembers)
    );
  }

  publicCreateOrUpdatePollAnswer(data:PublicCreateOrUpdatePollAnswerMutationModel){
    return this.apollo.mutate<any>({
      mutation: gql(PublicCreateOrUpdatePollAnswerMutation),
      variables: data
    }).pipe(
      map((result:any) => result.data.publicCreateOrUpdatePollAnswer)
    );
  }

  publicCreateFormAnswer(data:PublicCreateFormAnswerMutationModel){
    return this.apollo.mutate<any>({
      mutation: gql(PublicCreateFormAnswerMutation),
      variables: data
    }).pipe(
      map((result:any) => result.data.publicCreateFormAnswer)
    );
  }

  generateForm(form:FormPublication){
    let fields: FormlyFieldConfig[] = [];

    form.customFields.forEach(item => {
      switch(item.typeId){
        case TYPE_FORM_TEXT:
          fields.push({
            className: '',
            type: 'input',
            key: item.id,
            templateOptions: {
              required: item.require,
              label:item.name
            }
          });
        break;
        case TYPE_FORM_TEXT_AREA:
          fields.push({
            className: '',
            type: 'textarea',
            key: item.id,
            templateOptions: {
              required: item.require,
              label:item.name,
              rows: 8,
            }
          });
        break;
        case TYPE_FORM_CHECK:
          fields.push({
            className: '',
            type: 'custom-toggle',
            key: item.id,
            expressionProperties: {
              'templateOptions.label': item.name,
            },
            templateOptions: {
              required: item.require,
              label:item.name,
            }
          });
        break;
        case TYPE_FORM_COLOR:
          fields.push({
            className: '',
            type: 'color',
            key: item.id,
            defaultValue: '#c1c1c1',
            templateOptions: {
              label:item.name,
            },
          });
        break;
        case TYPE_FORM_NUMBER:
          fields.push({
            className: '',
            type: 'input',
            key: item.id,
            templateOptions: {
              type: 'number',
              label:item.name,
            },
          });
        break;
        case TYPE_FORM_DATE:
          fields.push({
            className: '',
            type: 'date',
            key: item.id,
            templateOptions: {
              label:item.name,
            },
          });
        break;
        case TYPE_FORM_DATETIME:
          fields.push({
            className: '',
            type: 'datetime',
            key: item.id,
            templateOptions: {
              label:item.name,
            }
          });
        break;
        case TYPE_FORM_EMAIL:
          fields.push({
            className: '',
            type: 'input',
            key: item.id,
            templateOptions: {
              type: 'email',
              label:item.name,
            },
            ...yulavaEmailFormlyConfig(this.translateService),
          });
        break;
        case TYPE_FORM_LIST_VALOURS:
          let options = [];
          item.listOfValours.forEach(value =>{
            options.push({label: value, value: value});
          });
          fields.push({
            className: '',
            type: 'select',
            key: item.id,
            templateOptions: {
              label: item.name,
              options: options,
            },
          });
        break;
      }
    });

    return fields;
  } */


}
